spec_version: "1.1"
id: mw-hipoteca
slug: mw-hipoteca
tipo_curso: monografico
nombre: "Tu primera hipoteca"
nombre_corto: "Hipoteca"
descripcion_corta: "Todo lo que necesitas saber antes, durante y después de firmar una hipoteca. Tipos, cláusulas, negociación y amortización."
idioma: es-ES
duracion_total_min: 180
audiencia: "Personas que están considerando comprar su primera vivienda"
editor: "MentorWallet"
version_curso: "0.1.0"
fecha_publicacion: "2026-07-01"
categorias:
  - finanzas-personales
  - vivienda
modalidad_predominante: mixto
modo_navegacion: "secuencial"
modulos:
  - 01-antes-de-firmar
  - 02-tipos-de-hipoteca
  - 03-negociacion
  - 04-despues-de-firmar
